module.exports = __webpack_public_path__ + "img/ios-share.a04bdbd9.svg";